import React, { MouseEventHandler } from 'react';
import { clsx } from 'clsx';
import styles from './wizard-buttons.module.scss';
import { Button } from '@components/button/button';
import { Tracking } from '@utils/tracking/types';
import { BackButton } from '@components/back-button/back-button';

type WizardButtonsType = {
  showBackButton: boolean;
  showNextButton: boolean;
  onClickBack?: () => void;
  onClickNext: MouseEventHandler<HTMLButtonElement>;
  labelNextButton?: string;
  fullWidthNextButton?: boolean;
  trackingNextButton?: Tracking;
  reverseButtonOrder?: boolean;
  backBtnClassName?: string;
  nextBtnClassName?: string;
};

export const WizardButtons: React.FC<WizardButtonsType> = ({
  showBackButton,
  showNextButton,
  onClickBack,
  onClickNext,
  fullWidthNextButton,
  trackingNextButton = {},
  labelNextButton = 'Weiter',
  reverseButtonOrder,
  backBtnClassName,
  nextBtnClassName
}) => (
  <div
    className={clsx({
      [styles.buttonGroup]: true,
      [styles.buttonGroupCentered]: !showBackButton,
      [styles.buttonGroupOrderReversed]: reverseButtonOrder
    })}
  >
    {showBackButton && onClickBack && (
      <BackButton
        btnClass={clsx(styles.backBtn, backBtnClassName)}
        onClick={onClickBack}
        label="zurück"
      />
    )}
    <Button
      className={clsx({
        [styles.nextBtn]: true,
        [styles.hideVisually]: !showNextButton,
        [styles.nextBtnFullWidth]: fullWidthNextButton,
        ...(nextBtnClassName && { [nextBtnClassName]: nextBtnClassName })
      })}
      onClick={onClickNext}
      tabIndex={1}
      data-testid="next-button"
      tracking={trackingNextButton}
    >
      {labelNextButton}
    </Button>
  </div>
);
